import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { arrayMove } from "react-sortable-hoc";
import "../style.css";
import { useEffect } from "react";
import TSDialog from "../../../general/dialog";
import TitleAndToggle from "./titleAndToggle";
import Item from "./item";
import { useDispatch } from "react-redux";
import { displayWarningToast } from "../../../../store/actions/overflowNotification";

const FormBuilderAsk = props => {
  const { bodyRequest, preview, onFormChange, onSetError, error, isDots, isDotsPreview} = props;

  const [title, setTitle] = useState(bodyRequest.title);
  const [isShared, setIsShared] = useState(bodyRequest.isShared);
  const [isPublic, setIsPublic] = useState(bodyRequest.isPublic);
  const [isForDots, setIsForDots] = useState(bodyRequest.isForDots);
  const [bodyItems, setBodyItems] = useState(bodyRequest.items);
  const [category, setCategory] = useState(bodyRequest.category);
  const [visibleDeleteDialog, setVisibleDeleteDialog] = useState(false);

  const formAdd = useIntl().formatMessage({ id: "ask.pages.edit.form.add" });
  const dispatch = useDispatch();
  useEffect(() => {
    onFormChange({
      title: title,
      category: category,
      items: bodyItems,
      isShared: isShared,
      isPublic: isPublic,
      isForDots: isForDots
    });
  }, [bodyItems, category, title, isShared, isPublic, isForDots]);

  useEffect(() => {
    setBodyItems(bodyRequest.items);
    setTitle(bodyRequest.title);
    setCategory(bodyRequest.category);
  }, [bodyRequest]);

  const onDotsChange = (value) => {
    setIsForDots(value);
  };

  const onAddItemClick = () => {
    let items = [];
    let cn = 0;
    bodyItems.map(item => {
      cn++;
      return items.push({
        id: cn,
        label: item.label,
        hint: item.hint,
        type: item.type,
        popover: item.popover,
        choices: item.choices,
        isRequired: item.isRequired
      });
    });
    items.push({
      id: cn + 1,
      label: "",
      type: "input",
      popover: false,
      isRequired: false
    });
    setBodyItems(items);
  };

  const confirmDelete = itemId => {
    let items = [];
    let cn = 0;
    bodyItems.map(item => {
      if (item.id !== itemId) {
        cn++;
        items.push({
          id: cn,
          label: item.label,
          hint: item.hint,
          type: item.type,
          popover: item.popover,
          choices: item.choices,
          isRequired: item.isRequired
        });
      }

      return null;
    });
    setBodyItems(items);
  };

  const renderDeleteDialog = () => {
    return (
      <TSDialog
        title={<FormattedMessage id="ask.builder.deleteTitle" />}
        okText={<FormattedMessage id="actions.delete" />}
        cancelText={<FormattedMessage id="actions.cancel" />}
        type="danger"
        visible={visibleDeleteDialog}
        onAbort={() => setVisibleDeleteDialog()}
        onSubmit={e => {
          confirmDelete(visibleDeleteDialog);
          setVisibleDeleteDialog();
        }}
      >
        <FormattedMessage id="ask.builder.deleteMessage" />
      </TSDialog>
    );
  };

  const onSortEnd = (itm, { oldIndex, newIndex }) => {
    const items = [];
    bodyItems.map(item => {
      if (item.id === itm.id) {
        item.choices = arrayMove(
          itm.choices,
          oldIndex,
          newIndex === oldIndex ? null : newIndex
        );
      }
      return items.push(item);
    });
    setBodyItems(items);
  };

  const onInputChange = (
    type, itemId, value, valueIndex
  ) => {
    let items = [];
    bodyItems.map(item => {
      let choices =
        item.choices &&
        (type !== "type" || (type === "type" && item.id !== itemId))
          ? item.choices
          : [];
      if (itemId === item.id && type === "type") {
        if (value === "radio" || value === "checkbox") {
          choices.push("");
        } else {
          choices = [];
        }
      }
      if (type === "addOption" && itemId === item.id) {
        choices.push("");
      }
      if (type === "editOption" && itemId === item.id) {
        choices[valueIndex] = value;
      }
      if (type === "removeOption" && itemId === item.id) {
        choices.splice(valueIndex, 1);
      }
      return items.push({
        id: item.id,
        label: itemId === item.id && type === "label" ? value : item.label,
        hint: itemId === item.id && type === "hint" ? value : item.hint,
        type: itemId === item.id && type === "type" ? value : item.type,
        choices: choices,
        isRequired:
          itemId === item.id && type === "isRequired" ? value : item.isRequired
      });
    });
    setBodyItems(items);
  };

  const moveItem = (itemId, direction) => {
    let tmpItems = [];
    bodyItems.map(item => {
      return tmpItems.push(item);
    });
    let element = tmpItems[bodyItems.find(x => x.id === itemId).id - 1];
    tmpItems.splice(bodyItems.find(x => x.id === itemId).id - 1, 1);
    tmpItems.splice(
      direction === "up"
        ? bodyItems.find(x => x.id === itemId).id - 2
        : bodyItems.find(x => x.id === itemId).id,
      0,
      element
    );
    let items = [];
    let cn = 0;
    tmpItems.map(item => {
      cn++;
      return items.push({
        id: cn,
        label: item.label,
        hint: item.hint,
        type: item.type,
        popover: false,
        choices: item.choices,
        isRequired: item.isRequired
      });
    });
    setBodyItems(items);
  };

  const renderItems = () => {

    let items = [];
    let cn = 0;
    bodyItems.map(item => {
      cn++;
      if (cn > 50){
        dispatch(displayWarningToast("è possibile inserire al massimo 50 domande.", "Attenzione"));
        delete bodyItems[50];
        return items;
      }
      return items.push(<Item
        bodyItems={bodyItems}
        cn={cn}
        item={item}
        preview={preview}
        moveItem={moveItem}
        onInputChange={onInputChange}
        setVisibleDeleteDialog={setVisibleDeleteDialog}
        onSortEnd={onSortEnd}
        isDots={isDots}
      />);
    });
    return items;
  };

  return (
    <div className={"askEdit-builder" + (preview ? " preview" : "")}>
      <TitleAndToggle
        preview={preview}
        title={title}
        isDots={isDots}
        isDotsPreview={isDotsPreview}
        onTitleChange={setTitle}
        bodyRequest={bodyRequest}
        onCategoryChange={setCategory}
        isShared={isShared}
        isForDots={isForDots}
        onSharedchange={value => {
          if (!value) {
            setIsShared(false);
            setIsPublic(false);
          } else {
            setIsShared(true);
          }
        }}
        isPublic={isPublic}
        onPublicChange={setIsPublic}
        error={error}
        onSetError={onSetError}
        onDotsChange={(value) => onDotsChange(value)}
      />
      {renderDeleteDialog()}
      <div className={"askEdit-builder-items" + (preview ? " preview" : "")}>
        {renderItems()}
      </div>
      {!preview && (
        <div className="askEdit-addItem" onClick={onAddItemClick}>
          <div className="askEdit-addItem-icon">
            <FontAwesomeIcon icon={["far", "plus"]} />
          </div>
          <div className="askEdit-addItem-text">
            {formAdd}
          </div>
        </div>
      )}
    </div>
  );
};

export default FormBuilderAsk;
